var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    {
      staticStyle: { "margin-bottom": "40px", "text-align": "center" },
      attrs: { "align-h": "center" }
    },
    [
      _c(
        "b-col",
        { attrs: { cols: "12", md: "5" } },
        [
          _c("h4", { staticClass: "font-weight-bold mb-4" }, [
            _vm._v("Input Your Donation")
          ]),
          _vm._v(" "),
          _c("b-form-group", [
            _c(
              "div",
              {
                staticClass:
                  "w-100 d-flex justify-content-between align-items-center mb-4 px-3"
              },
              [
                _c("div", { staticClass: "d-flex flex-column text-left" }, [
                  _c("span", { staticClass: "frequency-text" }, [
                    _vm._v("Donation Frequency")
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "d-flex flex-column text-right align-items-end"
                  },
                  [
                    _c("b-form-select", {
                      staticClass: "mb-0",
                      staticStyle: { width: "200px" },
                      attrs: { options: _vm.frequencyList },
                      model: {
                        value: _vm.frequency,
                        callback: function($$v) {
                          _vm.frequency = $$v
                        },
                        expression: "frequency"
                      }
                    })
                  ],
                  1
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "range-container" }, [
            _c(
              "div",
              { staticClass: "d-flex flex-column align-items-center mb-3" },
              [
                _c("span", { staticClass: "price-approx" }, [
                  _vm._v(_vm._s(_vm.approxText))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "price-text mb-1" }, [
                  _vm._v(
                    "$" +
                      _vm._s(
                        _vm.inputType === "slider"
                          ? _vm.sliderPrice
                          : _vm.inputPrice
                      )
                  )
                ]),
                _vm._v(" "),
                _vm.frequency !== "one-time"
                  ? _c("span", { staticClass: "price-per-month" }, [
                      _vm._v("/month")
                    ])
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _vm.inputType === "slider"
              ? _c(
                  "div",
                  { staticClass: "d-inline-block w-100 mb-5" },
                  [
                    _c("vue-slider", {
                      attrs: {
                        tooltip: "none",
                        min: 10,
                        max: 100,
                        height: 8,
                        "dot-size": 32,
                        "dot-style": { background: "#224181" },
                        "process-style": { background: "#224181" },
                        "rail-style": {
                          borderRadius: "0",
                          backgroundColor: "#AAAAAA"
                        },
                        "step-style": {
                          borderRadius: "0",
                          backgroundColor: "rgb(244, 242, 254)"
                        },
                        interval: 10,
                        marks: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
                        contained: true
                      },
                      on: { change: _vm.sliderPriceSelect },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "label",
                            fn: function(ref) {
                              var label = ref.label
                              var active = ref.active
                              return [
                                _c(
                                  "div",
                                  {
                                    class: [
                                      "vue-slider-mark-label",
                                      "custom-label",
                                      label === 10 || label === 100
                                        ? "must-show"
                                        : "must-hide",
                                      { active: active }
                                    ]
                                  },
                                  [_vm._v("$" + _vm._s(label))]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2690183347
                      ),
                      model: {
                        value: _vm.sliderPrice,
                        callback: function($$v) {
                          _vm.sliderPrice = $$v
                        },
                        expression: "sliderPrice"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.inputType === "input"
              ? _c(
                  "div",
                  {
                    staticClass: "d-inline-block w-100 mb-5 position-relative",
                    staticStyle: { height: "56px" }
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.inputPrice,
                          expression: "inputPrice"
                        }
                      ],
                      staticClass: "form-control input-custom-form",
                      attrs: { type: "number", min: "1", max: "100" },
                      domProps: { value: _vm.inputPrice },
                      on: {
                        keyup: _vm.inputChange,
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.inputPrice = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "position-absolute ml-2",
                      staticStyle: { top: "10px", left: "10px" },
                      attrs: { src: require("@/assets/dollar.svg") }
                    })
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex justify-content-center mb-5" }, [
              _c(
                "a",
                {
                  staticClass: "input-custom cursor-pointer",
                  on: { click: _vm.inputCustom }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.inputType === "slider"
                          ? "Input Custom Amount"
                          : "Back to Default"
                      ) +
                      "\n        "
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary btn-block mb-3",
                on: { click: _vm.pay }
              },
              [_vm._v("Go to payment")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "text-center d-flex flex-column align-items-center"
              },
              [
                _c(
                  "span",
                  {
                    staticStyle: {
                      "margin-top": "5px",
                      "margin-bottom": "-3px"
                    }
                  },
                  [_vm._v("*All prices exclusive of Stripe fees")]
                ),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    "*1% additional fee will be added for countries outside US"
                  )
                ])
              ]
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "w-100" }),
      _vm._v(" "),
      _c(
        "b-col",
        {
          staticClass: "d-flex justify-content-center",
          attrs: { cols: "12", md: "4" }
        },
        [
          _c(
            "a",
            {
              staticClass: "btn-back d-flex rounded-circle cursor-pointer",
              on: { click: _vm.back }
            },
            [
              _c("font-awesome-icon", {
                staticClass: "icon-back",
                attrs: { icon: ["fas", "chevron-left"] }
              })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-57d08c52", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57d08c52","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Donations.vue
// module id = null
// module chunks = 